import { useOnEvent } from 'context/EventEmitterContext'

export function useOnLinkedAccountChanged(fn: Callback) {
  useOnEvent('LINKED_ACCOUNT_CHANGED', fn)
}
